import { ButtonProps } from '@mui/material';
import { NavLink, NavLinkProps } from 'react-router';

import { NavigationItem } from '../types';

export const getCommonButtonProps = ({
  href,
  isComingSoon,
  isDisabled,
  isEnabled,
  label,
  onClick,
}: NavigationItem): ButtonProps<typeof NavLink, NavLinkProps> => ({
  disabled: !isEnabled && !isComingSoon && (!href || isDisabled),
  onClick,
  title: label,
  to: href || '',
  variant: 'text',
});
